import { Navigate } from "react-router";
import { useCurrentUser } from "../../hooks/use-current-user";
import { useAuth } from "../../hooks/use-auth";

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
	const auth = useAuth();
	const user = useCurrentUser();

	if (auth === "loading" || (auth === "authenticated" && user === null)) return null;
	if (auth === "unauthenticated") return <Navigate to="/login" replace />;
	if (!user?.admin) return <Navigate to="/" replace />;
	return <>{children}</>;
};

export default AdminRoute;
